import logoImg from '../../assets/images/users/The Tester logo white 2.png'

// ==============================|| LOGO IMAGE ||============================== //

export default function LogoMain() {
  return (
    <img src={logoImg} alt="TheTester" style={{ height: 28, display: 'block' }} />
  )
}
